








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Form extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly grid!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly inner!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly alignTop!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly maxWidth!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly noBorder!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly noMargin!: boolean;

  get classes() {
    const { grid, inner, alignTop, maxWidth, noBorder, noMargin } = this;
    const result: Array<string> = [];
    if (grid) result.push('form_grid');
    if (inner) result.push('form_inner');
    if (noMargin) result.push('form_no_margin');
    if (alignTop) result.push('form_top');
    if (maxWidth) result.push('form_width');
    if (noBorder) result.push('form_noborder');
    return result;
  }

  prevent(e: any) {
    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/Form.vue